
/* @flow */
const getters = {
  username: (state: any) => state.user.username,
  permission: (state: any) => state.user.permission,
  token: (state: any) => state.user.token,
  is_super: (state: any) => state.user.is_super,
  // username: state => state.user.username,
  // roleName: state => state.user.roleName,
  // phone: state => state.user.phone,
  // email: state:any => state.user.email,
  // realname: state => state.user.realname,
  // routers: state => state.permission.routers,
  addRouters: (state: any) => state.permission.addRouters
};

export default getters;